import { render, staticRenderFns } from "./idnex.vue?vue&type=template&id=f6889470&scoped=true&"
import script from "./idnex.vue?vue&type=script&lang=js&"
export * from "./idnex.vue?vue&type=script&lang=js&"
import style0 from "./idnex.vue?vue&type=style&index=0&id=f6889470&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6889470",
  null
  
)

export default component.exports